import React, { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'

// Signals Puppeteer that the page failed to load (loader error or render error)
const PrintReportErrorPage: React.FC = () => {
  const error = useRouteError()
  useEffect(() => {
    const msg = error instanceof Error ? error.message : String(error)
    document.documentElement.dataset.printError = msg || 'load error'
  }, [error])
  return <div>Error</div>
}

export default PrintReportErrorPage
